import React from "react";
import "./FrameworkCard.css";

interface FrameworkCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  glow?: string;
}

const FrameworkCard: React.FC<FrameworkCardProps> = ({
  icon,
  title,
  description,
  glow,
}) => {
  return (
    <div
      className="framework-card"
      style={{ "--glow-color": glow } as React.CSSProperties}
    >
      <div className="framework-icon">{icon}</div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
};

export default FrameworkCard;
